module.exports = __webpack_public_path__ + "img/placeholder.59c324e2.jpg";